<template>
  <div id="app">
    <loading :active.sync="isLoading" color="#64B9B0"></loading>
    <main :style="{ backgroundColor: empresa.cor_site_clara }">
      <p id="p1">
        Compliance
      </p>
      <br>
      <p id="p2">
        O que você gostaria de acessar?
      </p>
    </main>
  </div>
</template>

<script>
import { tratamento_requisicao } from "../../utils/util";
import axios from "axios";
export default {
	data() {
		return {
      empresa: {
        arquivo_logo: '',
        cor_site_escura: '',
        cor_site_media: '',
        cor_site_clara: '',
      }
		};
	},

  created() {
    this.isLoading = true
    let subUrl = window.location.hostname
    subUrl = subUrl.split('.')

    axios.get(`show_by_subdominio/${subUrl[0]}`)
      .then((res) => {
        this.isLoading = false
        this.empresa = res.data
      }, err => {
        this.isLoading = false
        tratamento_requisicao(err);
      })
  }
};
</script>

<style scoped>
#app {
  display: flex;
  flex-direction: column;
}

main {
  display: flex !important;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 5vh;
}

#p1 {
  color: #ffffff;
  font-size: 5vh;
  font-weight: bold;
  margin-bottom: 2vh;
}

#p2 {
  color: #ffffff;
  font-size: 4.2vh;
  font-weight: normal;
}

@media (max-width: 374px) {
  #p1 {
    font-size: 2rem;
  }

  #p2 {
    font-size: 1.5rem;
  }
}

@media (min-width: 375px) and (max-width: 576px) {
  #p1 {
    font-size: 3.5vh;
  }

  #p2 {
    font-size: 2.5vh;
  }
}

@media (min-width: 577px) and (max-width: 768px) {
  #p1 {
    font-size: 4vh;
  }

  #p2 {
    font-size: 3vh;
  }
}

@media (min-width: 769px) and (max-width: 992px) {
  #p1 {
    font-size: 4.5vh;
  }

  #p2 {
    font-size: 3.8vh;
  }
}

@media (min-width: 993px) and (max-width: 1200px) {
  #p1 {
    font-size: 4.8vh;
  }

  #p2 {
    font-size: 4vh;
  }
}
</style>